import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { Divider } from '@material-ui/core'
import {styles} from '../../CSS/Styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import TextField from '@material-ui/core/TextField'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import SimpleSelect from '../../CSSComponent/dropdownselection'
import Checkbox from '@material-ui/core/Checkbox'
import DatePicker from "react-datepicker";
import Button from '@material-ui/core/Button'
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  overrides: {
    MuiInput: {
      underline: {
        "&&&&:before": {
            borderBottom: "0px solid rgba(0, 0, 0, 0)"
        },
        "&&&&:hover:before": {
          borderBottom: "0px solid rgba(0, 0, 0, 0)"
        }
      }
    }
  }
});

class KRI extends React.Component {

    constructor(props) {
        super(props)
        console.log(this.props.kri)
        let kris = this.props.kri
        let kriNo = []
        let kriDescription = []
        let kriOwner=[]
        let kriFrequency =[]
        let kriLeftBound =[]
        let kriRightBound = []
        for (let itemindex in kris) {
            let item = kris[itemindex]
            kriNo.push(item.kri_id)
            kriDescription.push(item.kri_description)
            kriOwner.push(item.kri_owner)
            kriFrequency.push(item.frequency)
            kriLeftBound.push(item.kri_left_bound)
            kriRightBound.push(item.kri_right_bound)
        }

        this.state = {
            'kri': kris,
            'kriNo': kriNo,
            'kriDescription': kriDescription,
            'kriOwner': kriOwner,
            'kriFrequency': kriFrequency,
            'kriLeftBound': kriLeftBound,
            'kriRightBound': kriRightBound,
        }
    }

    componentDidUpdate(prevProps) {
        // console.log("new id : " + this.props.queryID + "vs old id : " + prevProps.queryID);
        if (this.props != prevProps) {
            console.log("kri props changede")
            let kris = this.props.kri
            let kriNo = []
            let kriDescription = []
            let kriOwner=[]
            let kriFrequency =[]
            let kriLeftBound =[]
            let kriRightBound = []
            for (let itemindex in kris) {
                let item = kris[itemindex]
                kriNo.push(item.kri_id)
                kriDescription.push(item.kri_description)
                kriOwner.push(item.kri_owner)
                kriFrequency.push(item.frequency)
                kriLeftBound.push(item.kri_left_bound)
                kriRightBound.push(item.kri_right_bound)
            }
            this.setState({
                'kri': kris,
                'kriNo': kriNo,
                'kriDescription': kriDescription,
                'kriOwner': kriOwner,
                'kriFrequency': kriFrequency,
                'kriLeftBound': kriLeftBound,
                'kriRightBound': kriRightBound,
            })
        }
    }

    handleDueDateChange = (date) => {
        //console.log('handleDueDateChange : ' + date)
        this.setState({'actionDueTimeline' : date})
    }
    //handleChange = (name, index) => event => {
    //    let checked = event.target.checked
    //    let newdata = this.state[name]
    //    newdata[index] = (checked ? '✔' : null)
    //    this.setState({[name]:newdata},()=>{
    //        this.props.submitChange(name, this.state[name])
    //    })
    //    this.forceUpdate()
    //    //console.log(name)
    //};

    handleChange = (name, index) => event => {
        let newdata = this.state[name]
        newdata[index] = (event.target.checked ? '✔' : null)
        this.setState({ [name]: newdata },()=>{
            this.props.submitChange(name, this.state[name])
        })
        //console.log(name)
    };

    handleListSelect = (key, value, index) => {
        //console.log(key, value)
        //let newdata = this.state[key] ? this.state[key] : []
        //newdata.push(value)
        console.log(key+index+':'+value)
        this.setState((state)=>{ this.state[key][index] = value }, ()=>{
            this.props.submitChange(key, this.state[key])
        })
    };


    handleTextChange = (name, index, event) => {
        //console.log(this.Risk_info_temp)
        let value = event.target.value
        this.setState((state)=>{ 
            this.state[name][index] = value 
            
            this.props.submitChange(name, this.state[name])
        })
        this.forceUpdate()
    };

    handleAddNew = (event) => {
        // get the type (as data-value in the dom element), here need to use its parent, because the event target return only the button not its wrapper
        //console.log(event.target.parentNode.dataset)
        //console.log(event.target.parentNode)
        let updateList = this.state.kri
        //console.log(this.state)
        //console.log(type)
        //console.log(updateList)
        updateList.push("")
        //console.log(updateList)
        this.setState({kri: updateList}, ()=>{
            this.props.submitChange('kri', updateList)
        })
    }

    handleDrop = (event) => {

        let index = event.target.parentNode.dataset.index
        // if click on the border of the button, it returns the parents........
        if (index == null) {
            index = event.target.dataset.index
        }
        console.log(index)
        let updateListkri = this.state.kri
        let updateListkriNo = this.state.kriNo
        let updateListkriDescription = this.state.kriDescription
        let updateListkriOwner = this.state.kriOwner
        let updateListkriFrequency = this.state.kriFrequency
        let updateListkriLeftBound = this.state.kriLeftBound
        let updateListkriRightBound = this.state.kriRightBound

        updateListkri.splice(index, 1)
        updateListkriNo.splice(index, 1)
        updateListkriDescription.splice(index, 1)
        updateListkriOwner.splice(index, 1)
        updateListkriFrequency.splice(index, 1)
        updateListkriLeftBound.splice(index, 1)
        updateListkriRightBound.splice(index, 1)

        this.setState({
            kri: updateListkri,
            kriNo: updateListkriNo,
            kriDescription: updateListkriDescription,
            kriOwner: updateListkriOwner,
            kriFrequency: updateListkriFrequency,
            kriLeftBound: updateListkriLeftBound,
            kriRightBound: updateListkriRightBound

        }, ()=>{
            this.props.submitChange('kri', updateListkri)
            this.props.submitChange('kriNo', updateListkriNo)
            this.props.submitChange('kriDescription', updateListkriDescription)
            this.props.submitChange('kriOwner', updateListkriOwner)
            this.props.submitChange('kriFrequency', updateListkriFrequency)
            this.props.submitChange('kriLeftBound', updateListkriLeftBound)
            this.props.submitChange('kriRightBound', updateListkriRightBound)
        })
    }

    render() {
        const { classes } = this.props;
        let namelist = []
        for (let list in this.props.employee) {
            namelist.push(this.props.employee[list].name + ', ' + this.props.employee[list].designation)
        }
        let KRIFrequencyOption = ['Annually', 'Monthly', 'Daily']
        console.log(this.state.kri)

        const KRITable =  (
            <div>
                <Table padding='dense'>
                    <TableHead>
                        <TableRow style={{height:'40px'}}>

                            <TableCell align = 'center' rowSpan={2} > No </TableCell>
                            <TableCell align = 'center' rowSpan={2} > Key Risk Indicator </TableCell>
                            <TableCell align = 'center' rowSpan={2} > KRI Owner </TableCell>
                            <TableCell align = 'center' rowSpan={2} > Freq. </TableCell>
                            <TableCell align = 'center' colSpan={3} > Thresholds</TableCell>
                        </TableRow>
                        <TableRow style={{height:'40px'}}>
                            <TableCell align = 'center' rowSpan={2} style={{ whiteSpace: 'nowrap',  padding: '10px 2px 10px 2px' }}> Green </TableCell>
                            <TableCell align = 'center' rowSpan={2} style={{ whiteSpace: 'nowrap',  padding: '10px 2px 10px 2px' }}> Amber </TableCell>
                            <TableCell align = 'center' rowSpan={2} style={{ whiteSpace: 'nowrap',  padding: '10px 2px 10px 2px' }}> Red </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {this.state.kri.map((controlitem, index)=>{
                            if (this.state.kriLeftBound == null || this.state.kriRightBound == null) {
                                return null
                            }
                            return(
                                <TableRow style={{height:'40px'}}>
                                    <TableCell align = 'center' style={{ width:'1%', padding: '10px 2px 10px 2px' }}>  
                                        <TextField
                                            id = "kriNo"
                                            InputProps={{ style: { fontSize: 15 }}}
                                            inputProps={{ style: { textAlign: "center" }}}
                                            onChange = {(event) => this.handleTextChange("kriNo", index, event)}
                                            value = {this.state.kriNo[index]}
                                            placeholder = "K1"
                                        />
                                        <Button
                                            data-index={index}
                                            variant='outlined'
                                            color='secondary'
                                            className={classes.button}
                                            onClick= {this.handleDrop}
                                        >
                                            Drop
                                        </Button>
                                    </TableCell>
                                    <TableCell align = 'center' style={{ padding: '10px 2px 10px 2px' }}>  
                                        <TextField
                                            style= {{width: '16vw'}}
                                            id = "kriDescription"
                                            className={classes.TextFieldUnderline}
                                            InputProps={{ style: { fontSize: 15 }}}
                                            inputProps={{ style: {overflow: "hidden" }}}
                                            multiline = {true}
                                            onChange = {(event) => this.handleTextChange("kriDescription", index, event)}
                                            value = {this.state.kriDescription[index]}
                                            placeholder = "Description"
                                        />  </TableCell>
                                    <TableCell align = 'center' style={{ padding: '10px 2px 10px 2px' }}> 
                                        <SimpleSelect index={index} id = 'kriOwner' option = {namelist}  defaultoption={namelist.findIndex(item => item == this.state.kriOwner[index])} returnSelection={this.handleListSelect}/>
                                    </TableCell>
                                    <TableCell align = 'center' style={{ padding: '10px 2px 10px 2px' }}>  
                                        <SimpleSelect index={index} id = 'kriFrequency' option = {KRIFrequencyOption}  defaultoption={KRIFrequencyOption.findIndex(item => item == this.state.kriFrequency[index])} returnSelection={this.handleListSelect}/>  
                                    </TableCell>
                                    <TableCell align = 'center' style={{ width:'1%', padding: '10px 2px 10px 2px', width:"7%" }}>   
                                        <TextField
                                            id = "kriLeftBound"
                                            InputProps={{ style: { fontSize: 15 }}}
                                            inputProps={{ style: { textAlign: "center" }}}
                                            onChange = {(event) => this.handleTextChange("kriLeftBound", index, event)}
                                            value = {this.state.kriLeftBound[index]}
                                            placeholder = "50%"
                                        />  </TableCell>
                                    <TableCell align = 'center' style={{ padding: '10px 2px 10px 2px' }}> {this.state.kriLeftBound[index]} to {this.state.kriRightBound[index]} </TableCell>
                                    <TableCell align = 'center' style={{ width:'1%', padding: '10px 2px 10px 2px', width:"7%"}}> 
                                        <TextField
                                            id = "kriRightBound"
                                            InputProps={{ style: { fontSize: 15 }}}
                                            inputProps={{ style: { textAlign: "center" }}}
                                            onChange = {(event) => this.handleTextChange("kriRightBound", index, event)}
                                            value = {this.state.kriRightBound[index]}
                                            placeholder = "30%"
                                        />   </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>

                </Table>
                <div className={classes.button_table_add_neww}>
                    <Button variant="outlined" color="primary" className={classes.button} onClick= {this.handleAddNew}>
                        Add New
                    </Button>
                </div>
            </div>
        )

        return(
            <MuiThemeProvider theme={theme}>
                <div>
                    <Typography variant = "h6"  align="left" className={classes.FormHeader}> F. Key Risk Indicators </Typography>
                    <Divider className={classes.FormDivider}/>
                    {KRITable}
                </div>
            </MuiThemeProvider>       
        )
    }
}

export default withStyles(styles)(KRI);
    


// WEBPACK FOOTER //
// ./src/components/Risks/RiskRegisterSection/F.js